/**
 * Check whether the browser is iOS based
 */
var isIOS = function isIOS() {
  return /(iPad|iPhone|iPod)/g.test( // We can't check "navigator === undefined"
  // @ts-ignore
  typeof navigator !== 'undefined' && navigator.userAgent);
};
/**
 * Check whether we are running in a React Native environment
 */


var isReactNative = function isReactNative() {
  return (// @ts-ignore
    typeof navigator !== 'undefined' && navigator.product === 'ReactNative'
  );
};

export { isIOS, isReactNative };